import * as Sentry from '@sentry/react';
import { Capacitor } from '@capacitor/core';

// Session Replay's rrweb recorder serialises every DOM mutation on the main
// thread. Inside the native WebView that lands exactly on route transitions
// (tearing down a ticker page and building 26 dashboard charts), so native
// ships without it — errors still report, just without a replay attached.
const isNativeApp = Capacitor.isNativePlatform();

// Initialize Sentry as early as possible
Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  // Setting this option to true will send default PII data to Sentry
  sendDefaultPii: true,
  // Set environment based on NODE_ENV
  environment: process.env.NODE_ENV,
  // Enable tracing for performance monitoring
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.1 : 1.0,
  // Enable session replay for error reproduction (web only, see above)
  replaysSessionSampleRate: isNativeApp ? 0 : 0.1,
  replaysOnErrorSampleRate: isNativeApp ? 0 : 1.0,
  // Only enable Sentry if DSN is configured
  enabled: !!process.env.REACT_APP_SENTRY_DSN,
  integrations: isNativeApp
    ? [Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] })]
    : [
        // Session replay for debugging
        Sentry.replayIntegration(),
        // Console logging integration - capture warnings and errors
        Sentry.consoleLoggingIntegration({ levels: ['warn', 'error'] }),
      ],
});

export { Sentry };
